import { useCallback, useEffect, useState } from 'react';
import type { Schedule } from '../api/types.ts';
import { useShop } from '../app/boot.tsx';
import { message } from '../lib/errors.ts';

export function useSchedule() {
  const { api } = useShop();
  const [data, setData] = useState<Schedule | null>(null);
  const [error, setError] = useState<string | null>(null);
  const reload = useCallback(async () => {
    setError(null);
    try {
      setData(await api.staff.schedule());
    } catch (e) {
      setError(message(e));
    }
  }, [api]);
  useEffect(() => { void reload(); }, [reload]);
  return { data, error, reload };
}

/** "HH:MM" → minutes; "00:00" as an end time means midnight (1440). */
export function toMinutes(hhmm: string, isEnd = false): number | null {
  const m = /^(\d{2}):(\d{2})$/.exec(hhmm);
  if (!m) return null;
  const v = Number(m[1]) * 60 + Number(m[2]);
  return isEnd && v === 0 ? 1440 : v;
}

export function fromMinutes(min: number): string {
  const m = min === 1440 ? 0 : min;
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
}
